export const Unauthorized = () => (
  <div className="content__wrapper">
    <div className="nodata__placeholder">
      <span className="icon-notification-circle" />
      <span>Accesso alla pagina non autorizzato!!!</span>
    </div>
  </div>
);
